<pace-fi-header></pace-fi-header>
<div>
    <router-outlet></router-outlet>
</div>
